import React, { useEffect, useState } from 'react';

import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Button,
  Select,
  Typography,
  Grid,
  MenuItem,
  Dialog,
  Stack,
  Modal,
  TableContainer,
  Paper,
  TableFooter,
} from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import { useParams, useLocation } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';

import { Api } from './webservices';

const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export default function WeekTable() {
  const [idMonth, setIdMonth] = useState('');
  const { search } = useLocation();
  const query = new URLSearchParams(search);

  const candidateName = query.get('candidateName');
  const companyName = query.get('companyName');
  const email = query.get('email');
  const jobTitle = query.get('jobTitle');
  const phone = query.get('phone');
  const id = query.get('placementId');
  const clickedButton = query.get('clickedButton');
  const endClientName = query.get('endClientName');
  const placementId = query.get('placementId');
  const reportingManagerEmail = query.get('reportingManagerEmail');
  const reportingManagerName = query.get('reportingManagerName');
  const reportingManagerNumber = query.get('reportingManagerNumber');

  const [openApproveModal, setOpenApproveModal] = useState(false);
  const [approvedayId, setdayapproveId] = useState();

  const { token } = useParams();
  console.log(useParams());
  //  console.log("diagam====>>", token);

  const isFromBtn1 = clickedButton === 'btn1';

  const today = new Date();
  const currentMonth = today.getMonth() + 1;
  const currentYear = today.getFullYear();

  const [selectedMonth, setSelectedMonth] = useState(currentMonth);
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [weeksData, setWeeksData] = useState([]);

  const [TokenData, setTokenData] = useState({});

  const tablebg = 'rgba(82, 130, 190, 0.08)';

  const [openDisapproveModal, setOpenDisapproveModal] = useState(false);
  const [disapproveNote, setDisapproveNote] = useState('');
  const [selectedDayId, setSelectedDayId] = useState(null);

  /* ================= API ================= */

  const saveDay = async (wIdx, dIdx, id1) => {
    //  const token = localStorage.getItem("token");
    const day = weeksData[wIdx].days[dIdx];

    const payload = {
      dayId: day._id,
      timeIn: day.timeIn,
      break: day.break,
      timeOut: day.timeOut,
      timeOff: day.timeOff,
      overtime: day.overtime,
      leave: day.timeOff,
      weekId: id1,
      candidateId: token !== 'withouttoken' ? TokenData.candidateId : id,
    };

    try {
      await Api(
        'timeSheet/updateTimeWork',
        'POST',
        payload
        //   token
      );

      if (token !== 'withouttoken') {
        fetchTimesheet2();
      } else {
        fetchTimesheet();
      }
    } catch (err) {
      console.error('Save failed', err);
    }
  };

  function fun(dayid) {
    setdayapproveId(dayid);
    setOpenApproveModal(true);
  }

  const approveTime = async (dayId1) => {
    //  const token = localStorage.getItem("token");

    const payload = {
      dayId: approvedayId,
      approvalStatus: 'Approved',
    };

    Api(
      'timeSheet/updateTimeWork',
      'POST',
      payload
      //   token
    )
      .then((res) => {
        if (res.status === 200) {
          toast.success(res.data.message);
          if (token !== 'withouttoken') {
            fetchTimesheet2();
            setOpenApproveModal(false);
          } else {
            fetchTimesheet();
            setOpenApproveModal(false);
          }
        } else {
          toast.error(res.data.error);
        }
      })
      .catch(() => {});
  };

  const disapproveTime = async () => {
    if (!disapproveNote.trim()) {
      toast.error('Please enter note ');
      return;
    }

    // const token = localStorage.getItem("token");

    const payload = {
      dayId: selectedDayId,
      approvalStatus: 'Disapproved',
      Note: disapproveNote,
    };

    Api(
      'timeSheet/updateTimeWork',
      'POST',
      payload
      //    token
    )
      .then((res) => {
        if (res.status === 200) {
          toast.success(res.data.message);
          if (token !== 'withouttoken') {
            fetchTimesheet2();
          } else {
            fetchTimesheet();
          }

          setOpenDisapproveModal(false);
        } else {
          toast.error(res.data.error);
        }
      })
      .catch((res) => {
        console.error('Disapprove failed', res);
      });
  };

  const openDisapprove = (dayId) => {
    setSelectedDayId(dayId);
    setDisapproveNote('');
    setOpenDisapproveModal(true);
  };

  const fetchTimesheet = () => {
    const token = localStorage.getItem('token');
    const body = {
      month: selectedMonth,
      year: selectedYear,
      candidateId: id,
    };

    Api('timeSheet/generateTimesheet', 'POST', body)
      .then((res) => {
        console.log('hyeeee===========>>>>>>&&&& +++++', res);

        if (res.status === 200) {
          setIdMonth(res?.data?._id);
          const weeks = res?.data?.weeks || [];
          const formatted = weeks.map((w) => ({
            weekNumber: w.weekNumber,
            paymentStatus: w.paymentStatus,
            generatedBy: w.generatedBy,
            totalHoursPerWeek: w.totalHoursPerWeek,

            id: w._id,
            days: w.days.map((d) => ({
              ...d,
              editMode: false,
            })),
          }));
          console.log('hyeeeeeeeeeeeuuuoo ', formatted);
          setWeeksData(formatted);
        } else {
          console.log('error hello shyammlal  ');
        }
      })
      .catch(() => setWeeksData([]));
  };

  const fetchTimesheet2 = () => {
    //  const token = localStorage.getItem("token");
    const body = {
      month: selectedMonth,
      year: selectedYear,
      "token": token,
    };

    Api('timeSheet/generate-timesheet-link', 'POST', body, token)
      .then((res) => {
        if (res?.data?.responseCode === 440) {
          setInvalidToken(true);
          return;
        }

        console.log('hyyye thghghghghhis is ', res);

        if (res.status === 200) {
          setIdMonth(res?.data?._id);
          const weeks = res?.data?.timesheet.weeks || [];
          setTokenData(res.data.tokenData);
          const formatted = weeks.map((w) => ({
            weekNumber: w.weekNumber,
            generatedBy: w.generatedBy,
            totalHoursPerWeek: w.totalHoursPerWeek,
            id: w._id,
            paymentStatus: w.paymentStatus,
            days: w.days.map((d) => ({
              ...d,
              editMode: false,
            })),
          }));
          setWeeksData(formatted);
        } else {
          console.log('error hello shyammlal  ');
        }
      })
      .catch(() => setWeeksData([]));
  };

  useEffect(() => {
    if (token !== 'withouttoken') {
      fetchTimesheet2();
    } else {
      fetchTimesheet();
    }
    // if(token)
    // {
    //         fetchTimesheet2();
    // }
    // else{
    //       fetchTimesheet();
    // }
  }, [selectedMonth, selectedYear, id]);

  /* ================= MONTH HANDLERS ================= */
  const handlePrevMonth = () => {
    if (selectedMonth === 1) {
      setSelectedMonth(12);
      setSelectedYear((y) => y - 1);
    } else {
      setSelectedMonth((m) => m - 1);
    }
  };

  const handleNextMonth = () => {
    if (selectedYear > currentYear || (selectedYear === currentYear && selectedMonth >= currentMonth)) return;

    if (selectedMonth === 12) {
      setSelectedMonth(1);
      setSelectedYear((y) => y + 1);
    } else {
      setSelectedMonth((m) => m + 1);
    }
  };

  /* ================= TABLE HANDLERS ================= */
  // const toggleEdit = (wIdx, dIdx) => {
  //   const copy = [...weeksData];
  //   copy[wIdx].days[dIdx].editMode =
  //     !copy[wIdx].days[dIdx].editMode;
  //   setWeeksData(copy);
  // };

  const editDisAprove = async (selectedDayId) => {
    // if (!disapproveNote.trim()) {
    //    toast.error("Please enter note ");
    //   return;
    // }

    // const token = localStorage.getItem("token");

    const payload = {
      dayId: selectedDayId,
      approvalStatus: '',
      Note: '',
    };

    Api(
      'timeSheet/updateTimeWork',
      'POST',
      payload
      //    token
    )
      .then((res) => {
        if (res.status === 200) {
          toast.success(res.data.message);
          if (token !== 'withouttoken') {
            fetchTimesheet2();
          } else {
            fetchTimesheet();
          }

          // setOpenDisapproveModal(false);
        } else {
          toast.error(res.data.error);
        }
      })
      .catch((res) => {
        console.error('Disapprove failed', res);
      });
  };

  //  const toggleEdit = (wIdx, dIdx , id) => {
  //              const copy = [...weeksData];
  //              copy[wIdx].days[dIdx].editMode = true;
  //                setWeeksData(copy);
  //             //   editDisAprove(id)
  //           };

  const toggleEdit = (wIdx, dIdx) => {
    setWeeksData((prev) =>
      prev.map((w, wi) =>
        wi === wIdx
          ? {
              ...w,
              days: w.days.map((d, di) => (di === dIdx ? { ...d, editMode: true } : d)),
            }
          : w
      )
    );
  };

  //   const handleChange = (wIdx, dIdx, key, value) => {
  //   const copy = [...weeksData];
  //   copy[wIdx].days[dIdx][key] = value;
  //   setWeeksData(copy);
  // };

  // const handleChange = (wIdx, dIdx, key, value) => {
  //   if (key === "workingHours" || key === "totalHours") return;
  //        const copy = [...weeksData];
  //        copy[wIdx].days[dIdx][key] = value;
  //        setWeeksData(copy);
  // };

  // const handleChange = (wIdx, dIdx, key, value) => {
  //   if (key === "workingHours" || key === "totalHours") return;

  //   const copy = [...weeksData];
  //   const day = copy[wIdx].days[dIdx];

  //   //  Jab TimeIn change ho
  //   if (key === "timeIn") {
  //     if (day.timeOut) {
  //       const inMin = timeToMinutes(value);
  //       const outMin = timeToMinutes(day.timeOut);

  //       if (outMin < inMin) {

  //         day.timeOut = "";
  //       }
  //     }
  //   }

  //   day[key] = value;
  //   setWeeksData(copy);
  // };

  const handleChange = (wIdx, dIdx, key, value) => {
    if (key === 'workingHours' || key === 'totalHours') return;

    setWeeksData((prev) =>
      prev.map((w, wi) => {
        if (wi !== wIdx) return w;

        return {
          ...w,
          days: w.days.map((d, di) => {
            if (di !== dIdx) return d;

            const updatedDay = { ...d, [key]: value };

            //  TimeIn change logic (tumhara same logic)
            if (key === 'timeIn' && d.timeOut) {
              const inMin = timeToMinutes(value);
              const outMin = timeToMinutes(d.timeOut);

              if (outMin < inMin) {
                updatedDay.timeOut = '';
              }
            }
            return updatedDay;
          }),
        };
      })
    );
  };

  // const approveRow = (wIdx, dIdx) => {
  //   const copy = [...weeksData];
  //   copy[wIdx].days[dIdx].approved = true;
  //   setWeeksData(copy);
  // };

  const generateTimeOptions = () => {
    const options = [];
    for (let h = 0; h <= 24; h += 1) {
      for (let m = 0; m < 60; m += 15) {
        if (h === 24 && m > 0) break;
        const hour = h.toString().padStart(2, '0');
        const min = m.toString().padStart(2, '0');
        options.push(`${hour}:${min}`);
      }
    }
    return options;
  };

  const timeOptions = generateTimeOptions();

  const generateBreakOptions = () => {
    const options = [];

    for (let hour = 0; hour < 24; hour += 1) {
      for (let minute = 0; minute < 60; minute += 15) {
        const hh = hour.toString().padStart(2, '0');
        const mm = minute.toString().padStart(2, '0');
        options.push(`${hh}:${mm}`);
      }
    }
    return options;
  };

  function updateWeekPaymentStatus(id, weekNumber) {
    console.log('hello shyamlal===>>', id, weekNumber);

    const body = {
      weekId: id,
      "weekNumber": weekNumber,
      paymentStatus: 'Paid',
    };

    Api('timeSheet/update-weekPayment-status', 'POST', body)
      .then((res) => {
        console.log('update====>>', res);
        if (res.status === 200) {
          toast.success(res.data.message);
          if (token !== 'withouttoken') {
            fetchTimesheet2();
          } else {
            fetchTimesheet();
          }
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((res) => {
        console.error(' updateWeekPaymentStatus failed', res);
      });
  }

  const breakOptions = generateBreakOptions();

  const timeToMinutes = (time) => {
    if (!time) return 0;
    const [h, m] = time.split(':').map(Number);
    return h * 60 + m;
  };

  const minutesToTime = (minutes) => {
    const h = Math.floor(minutes / 60);
    const m = minutes % 60;
    return `${h}:${m.toString().padStart(2, '0')}`;
  };

  // const getWeekTotals = (days) => {
  //   let workingMin = 0;
  //   let overtimeMin = 0;
  //   let totalMin = 0;

  //   days.filter(d => d.approvalStatus === "Approved") .forEach((d) => {
  //     workingMin += timeToMinutes(d.workingHours);
  //     overtimeMin += timeToMinutes(d.overtime);
  //     totalMin += timeToMinutes(d.totalHours);
  //   });

  //   return {
  //     working: minutesToTime(workingMin),
  //     overtime: minutesToTime(overtimeMin),
  //     total: minutesToTime(totalMin),
  //   };
  // };

  const getWeekTotals = (week = {}) => {
    let workingMin = 0;
    let overtimeMin = 0;
    let totalMin = 0;

    if (week?.generatedBy === 'Mannually') {
      const mins = timeToMinutes(week?.totalHoursPerWeek || '0:00');
      return {
        working: minutesToTime(mins),
        overtime: '0:00',
        total: minutesToTime(mins),
      };
    }

    week?.days?.forEach((d) => {
      if (d.approvalStatus === 'Approved') {
        workingMin += timeToMinutes(d.workingHours);
        overtimeMin += timeToMinutes(d.overtime);
        totalMin += timeToMinutes(d.totalHours);
      }
    });

    return {
      working: minutesToTime(workingMin),
      overtime: minutesToTime(overtimeMin),
      total: minutesToTime(totalMin),
    };
  };

  const getAllWeeksTotals = (weeks) => {
    // console.log("hello6745==>", weeks )
    let workingMin = 0;
    let overtimeMin = 0;
    let totalMin = 0;

    weeks?.forEach((week) => {
      if (week?.generatedBy === 'Mannually') {
        workingMin += timeToMinutes(week?.totalHoursPerWeek);
        totalMin += timeToMinutes(week?.totalHoursPerWeek);
      } else {
        week.days
          .filter((d) => d.approvalStatus === 'Approved')
          .forEach((d) => {
            workingMin += timeToMinutes(d.workingHours);
            overtimeMin += timeToMinutes(d.overtime);
            totalMin += timeToMinutes(d.totalHours);
          });
      }
    });

    return {
      working: minutesToTime(workingMin),
      overtime: minutesToTime(overtimeMin),
      total: minutesToTime(totalMin),
    };
  };

  const allTotals = getAllWeeksTotals(weeksData);

  const getFilteredTimeOutOptions = (timeIn) => {
    if (!timeIn) return timeOptions;
    const inMinutes = timeToMinutes(timeIn);
    return timeOptions.filter((t) => timeToMinutes(t) >= inMinutes);
  };

  const handleMarkMonthPaid = () => {
    if (!idMonth) {
      console.warn('Timesheet ID not found');
      return;
    }

    const body = {
      timesheetId: idMonth,
    };

    Api('timeSheet/update-monthlyPayment-status', 'POST', body)
      .then((res) => {
        console.log('====>>>>>jhjbdfd', res);
        if (res?.status === 200) {
          toast.success(res.data.message);
          if (token !== 'withouttoken') {
            fetchTimesheet2();
          } else {
            fetchTimesheet();
          }
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        console.log('Payment update failed', err);
      });
  };

  let allPaid = true;

  const [invalidToken, setInvalidToken] = useState(false);

  if (invalidToken) {
    return (
      <Modal open={Boolean(true)}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            border: '2px solid #3C6BA5',
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
            textAlign: 'center',
          }}
        >
          <Typography variant="h6" color="error" mb={2}>
            This link has been expired
          </Typography>

          <Typography>This link is no longer valid.</Typography>
        </Box>
      </Modal>
    );
  }

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: 2,
          marginTop: 10,
          mb: 0.5,
        }}
      >
        <Button onClick={handlePrevMonth}>◀</Button>

        <Typography sx={{ fontWeight: 700 }}>
          {monthNames[selectedMonth - 1]} {selectedYear}
        </Typography>

        <Button
          onClick={handleNextMonth}
          disabled={selectedYear > currentYear || (selectedYear === currentYear && selectedMonth >= currentMonth)}
        >
          ▶
        </Button>
      </Box>

      <Box
        sx={{
          border: '5px solid rgba(60, 107, 165, 1)',
          borderRadius: '12px',
          padding: '8px',
          backgroundColor: '#f8fbff',

          mx: {
            xs: '4px',
            sm: '24px',
            md: '50px',
            lg: '80px',
          },

          mb: {
            xs: '24px',
            md: '80px',
          },
        }}
      >
        <Box
          sx={{
            p: {
              xs: 0,
              sm: 1,
              md: 3,
              lg: 4,
            },
          }}
        >
          <ToastContainer />

          <Grid container spacing={2} mb={3}>
            {/* Box 1 */}
            <Grid item xs={12} md={4}>
              <Box
                sx={{
                  border: '4px solid #000',
                  borderRadius: '12px',
                  padding: '10px',
                  background: '#f8fbff',
                  height: { xs: 'auto', md: 100 },
                  overflow: 'hidden',
                }}
              >
                <Typography>
                  <b>Candidate Id:</b>{' '}
                  <span style={{ color: '#3C6BA5', fontWeight: 'bold' }}>{id || TokenData.candidateId}</span>
                </Typography>
                <Typography>
                  <b>Name :</b>{' '}
                  <span style={{ color: '#3C6BA5', fontWeight: 'bold' }}>
                    {candidateName || TokenData?.candidateName
                      ? (candidateName || TokenData?.candidateName).charAt(0).toUpperCase() +
                        (candidateName || TokenData?.candidateName).slice(1)
                      : '-'}
                  </span>
                </Typography>
                <Typography>
                  <b>Email :</b>{' '}
                  <span style={{ color: '#3C6BA5', fontWeight: 'bold' }}>
                    {email || TokenData?.email
                      ? (email || TokenData?.email).charAt(0).toUpperCase() + (email || TokenData?.email).slice(1)
                      : '-'}
                  </span>
                </Typography>
                <Typography>
                  <b>Job Title :</b>{' '}
                  <span style={{ color: '#3C6BA5', fontWeight: 'bold' }}>{jobTitle || TokenData?.jobTitle || '-'}</span>
                </Typography>
              </Box>
            </Grid>
            {/* Box 2 */}
            <Grid item xs={12} md={4}>
              <Box
                sx={{
                  border: '4px solid #000',
                  borderRadius: '12px',
                  padding: '10px',
                  background: '#f8fbff',
                  height: { xs: 'auto', md: 100 }, // responsive height
                  overflow: 'hidden',
                }}
              >
                <Typography>
                  <b>Client Name :</b>{' '}
                  <span style={{ fontWeight: 'bold', color: '#3C6BA5' }}>
                    {endClientName || TokenData?.endClientName
                      ? (endClientName || TokenData?.endClientName).charAt(0).toUpperCase() +
                        (endClientName || TokenData?.endClientName).slice(1)
                      : '-'}
                  </span>
                </Typography>

                <Typography>
                  <b>Address:</b> 1358 Sandal Suites, Bon House, Jersey City, NJ 133217 this is static
                </Typography>
              </Box>
            </Grid>
            {/* Box 3 */}
            <Grid item xs={12} md={4}>
              <Box
                sx={{
                  border: '4px solid #000',
                  borderRadius: '12px',
                  padding: '10px',
                  background: '#f8fbff',
                  height: { xs: 'auto', md: 100 }, // responsive height
                  overflow: 'hidden',
                }}
              >
                <Typography>
                  <b>Reporting Manager :</b>{' '}
                  <span style={{ fontWeight: 'bold', color: '#3C6BA5' }}>
                    {reportingManagerName || TokenData?.reportingManagerName
                      ? (reportingManagerName || TokenData?.reportingManagerName).charAt(0).toUpperCase() +
                        (reportingManagerName || TokenData?.reportingManagerName).slice(1)
                      : '-'}
                  </span>
                </Typography>
                <Typography>
                  <b>Email :</b>{' '}
                  <span style={{ fontWeight: 'bold', color: '#3C6BA5' }}>
                    {reportingManagerEmail || TokenData?.reportingManagerEmail
                      ? (reportingManagerEmail || TokenData?.reportingManagerEmail).charAt(0).toUpperCase() +
                        (reportingManagerEmail || TokenData?.reportingManagerEmail).slice(1)
                      : '-'}
                  </span>
                </Typography>
              </Box>
            </Grid>
          </Grid>

          <Grid container mb={2} spacing={2}>
            <Grid item xs={12} md={8.9}>
              <Box
                sx={{
                  background: tablebg,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  border: '1px solid #3C6BA5',
                  //  p: 1,
                  fontWeight: 700,
                  textAlign: 'center',
                  height: '26px',
                  borderRadius: '8px',
                }}
              >
                Details
              </Box>
            </Grid>

            <Grid item xs={12} md={3.1}>
              <Box
                sx={{
                  background: tablebg,

                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  border: '1px solid #3C6BA5',
                  //   p: 1,
                  fontWeight: 700,
                  height: '26px',
                  textAlign: 'center',
                  borderRadius: '8px',
                }}
              >
                Action
              </Box>
            </Grid>
          </Grid>

          {/* <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: 2,
          mb: 3,
        }}
      >
        <Button onClick={handlePrevMonth}>◀</Button>

        <Typography sx={{ fontWeight: 700 }}>
          {monthNames[selectedMonth - 1]} {selectedYear}
        </Typography>

        <Button
          onClick={handleNextMonth}
          disabled={
            selectedYear > currentYear ||
            (selectedYear === currentYear && selectedMonth >= currentMonth)
          }
        >
          ▶
        </Button>
      </Box> */}

          {weeksData.map((week, wIdx) => {
            //    week.every

            console.log('=====>', week._id);

            if (week.paymentStatus === '') allPaid = false;
            //   weeksData.every((week) => week.paymentStatus === "Paid");
            const isWeekActionCompleted = week.days.every(
              (day) => day.approvalStatus === 'Approved' || day.approvalStatus === 'Disapproved'
            );
            // const totals = getWeekTotals(week.days);
            const totals = getWeekTotals(week);
            return (
              <Box key={wIdx} sx={{ mb: 4 }}>
                {/* WEEK + TABLE */}
                <Box sx={{ display: 'flex', overflowX: 'auto' }}>
                  {/* <Box
                sx={{
                  background: tablebg,
                  border: "2px solid #3C6BA5",
                  borderRadius: "10px",
                  writingMode: "vertical-rl",
                  textOrientation: "upright",
                  


                  fontWeight: 700,
                  px: 1,
                  mr: 1,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                WEEK {week.weekNumber}
              </Box> */}

                  <Box
                    sx={{
                      background: tablebg,
                      border: '1px solid #3C6BA5',
                      borderRadius: '10px',

                      writingMode: 'vertical-rl',
                      textOrientation: 'mixed',
                      fontSize: '18px',
                      transform: 'rotate(180deg)',
                      width: '26px',

                      fontWeight: 700,
                      px: 1,
                      mr: 1,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    Week {week.weekNumber}
                  </Box>

                  <TableContainer sx={{ borderRadius: '15px', border: '2px solid #1E74B3' }}>
                    <Table sx={{ minWidth: 900, borderLeft: 'none', borderRight: 'none' }}>
                      <TableHead>
                        <TableRow>
                          {[
                            'Day / Date',
                            'Time In',
                            'Break',
                            'Time Out',
                            'Time Off',
                            'Working Hours',
                            'Overtime',
                            'Total Hours',
                            'Edit',
                            'Approve /Reject',
                          ].map((h) => (
                            <TableCell
                              key={h}
                              sx={{
                                border: '1px solid #a4b0bf',
                                borderLeft: 'none',
                                borderTop: 'none',
                                fontWeight: 700,
                                textAlign: 'center',
                                py: 0.3,
                              }}
                            >
                              {h}
                            </TableCell>
                          ))}
                        </TableRow>
                      </TableHead>
                      <TableBody sx={{ borderLeft: 'none', borderRight: 'none' }}>
                        {week.days.map((row, i) => (
                          <TableRow key={i} sx={{ py: 0, my: 0 }}>
                            {/* Day / Date */}
                            <TableCell
                              sx={{
                                border: '1px solid #a4b0bf',
                                borderLeft: 'none',
                                borderBottom: 'none',
                                textAlign: 'center',
                                py: 0.2,
                              }}
                            >
                              {row.day} -{' '}
                              {new Date(+row.date)
                                .toLocaleDateString('en-US', {
                                  month: 'short',
                                  day: '2-digit',
                                  year: 'numeric',
                                })
                                .replace(',', '')
                                .replace(/ /g, '-')}
                            </TableCell>

                            {/* Time In */}

                            {/* <TableCell sx={{ border: "2px solid #3C6BA5", textAlign: "center" , py: 0.5,}}>
        {row.editMode ? (
          <TextField
            size="small"
            value={row.timeIn}
            onChange={(e) => handleChange(wIdx, i, "timeIn", e.target.value)}
          />
        ) : (
          row.timeIn
        )} 
             
          















      </TableCell>  */}

                            <TableCell
                              sx={{
                                border: '1px solid #a4b0bf',
                                textAlign: 'center',
                                borderBottom: 'none',
                                borderLeft: 'none',
                                borderRight: 'none',
                                py: 0.2,
                              }}
                            >
                              {row.editMode ? (
                                <Select
                                  size="small"
                                  value={row.timeIn || ''}
                                  onChange={(e) => handleChange(wIdx, i, 'timeIn', e.target.value)}
                                  sx={{ minWidth: 90 }}
                                >
                                  {timeOptions.map((t) => (
                                    <MenuItem key={t} value={t}>
                                      {t}
                                    </MenuItem>
                                  ))}
                                </Select>
                              ) : (
                                row.timeIn
                              )}
                            </TableCell>

                            {/* Break */}

                            {/* 
      <TableCell sx={{ border: "2px solid #3C6BA5", textAlign: "center" , py: 0.5,}}> 
        {row.editMode ? (
          <TextField
                 size="small"
                 value={row.break}
                 onChange={(e) => handleChange(wIdx, i, "break", e.target.value)}
          />
        ) : (
                 row.break 
        )}
      </TableCell> */}

                            <TableCell
                              sx={{ border: '1px solid #a4b0bf', borderBottom: 'none', textAlign: 'center', py: 0.2 }}
                            >
                              {row.editMode ? (
                                <TextField
                                  select
                                  size="small"
                                  value={row.break || ''}
                                  onChange={(e) => handleChange(wIdx, i, 'break', e.target.value)}
                                  sx={{ minWidth: 90 }}
                                >
                                  {breakOptions.map((b) => (
                                    <MenuItem key={b} value={b}>
                                      {b}
                                    </MenuItem>
                                  ))}
                                </TextField>
                              ) : (
                                row.break
                              )}
                            </TableCell>

                            {/* Time Out */}
                            {/* <TableCell sx={{ border: "2px solid #3C6BA5", textAlign: "center" , py: 0.5,}}>
        {row.editMode ? (
          <TextField
            size="small"
            value={row.timeOut}
            onChange={(e) => handleChange(wIdx, i, "timeOut", e.target.value)} 
          />
        ) : (
          row.timeOut
        )}
      </TableCell> */}

                            <TableCell
                              sx={{ border: '1px solid #a4b0bf', textAlign: 'center', borderBottom: 'none', py: 0.2 }}
                            >
                              {row.editMode ? (
                                <Select
                                  size="small"
                                  value={row.timeOut || ''}
                                  onChange={(e) => handleChange(wIdx, i, 'timeOut', e.target.value)}
                                  sx={{ minWidth: 90 }}
                                >
                                  {getFilteredTimeOutOptions(row.timeIn).map((t) => (
                                    <MenuItem key={t} value={t}>
                                      {t}
                                    </MenuItem>
                                  ))}
                                </Select>
                              ) : (
                                row.timeOut
                              )}
                            </TableCell>

                            {/* Time Off */}
                            <TableCell
                              sx={{ border: '1px solid #a4b0bf', borderBottom: 'none', textAlign: 'center', py: 0.2 }}
                            >
                              {row.editMode ? (
                                <Select
                                  size="small"
                                  value={row.timeOff}
                                  onChange={(e) => handleChange(wIdx, i, 'timeOff', e.target.value)}
                                >
                                  <MenuItem value="">-</MenuItem>
                                  <MenuItem value="Paid">Paid</MenuItem>
                                  <MenuItem value="Unpaid">Unpaid</MenuItem>
                                </Select>
                              ) : (
                                row.timeOff
                              )}
                            </TableCell>

                            {/* Working Hours */}
                            {/* <TableCell sx={{ border: "2px solid #3C6BA5", textAlign: "center" }}>
        {row.editMode ? (
          <TextField
            size="small"
            value={row.workingHours}
            onChange={(e) => handleChange(wIdx, i, "workingHours", e.target.value)}
          />
        ) : (
          row.workingHours
        )}
      </TableCell> */}

                            {/* Working Hours */}
                            <TableCell
                              sx={{ borderBottom: 'none', textAlign: 'center', py: 0.2, border: '1px solid #a4b0bf' }}
                            >
                              <Box>
                                <Box sx={{ color: row.approvalStatus === 'Disapproved' ? 'red' : 'none' }}>
                                  {row.workingHours}
                                </Box>
                              </Box>
                              {/* {row.workingHours} */}
                            </TableCell>
                            {/* Overtime */}

                            {/* <TableCell sx={{ border: "2px solid #3C6BA5", textAlign: "center" , py: 0.5,}}>
        {row.editMode ? (
          <TextField
            size="small" 
            value={row.overtime}
            onChange={(e) => handleChange(wIdx, i, "overtime", e.target.value)}
          />
        ) : (
          row.overtime 
        )}
      </TableCell> */}

                            <TableCell
                              sx={{ border: '1px solid #a4b0bf', borderBottom: 'none', textAlign: 'center', py: 0.2 }}
                            >
                              {row.editMode ? (
                                <TextField
                                  select
                                  size="small"
                                  value={row.overtime || ''}
                                  onChange={(e) => handleChange(wIdx, i, 'overtime', e.target.value)}
                                  sx={{ minWidth: 90 }}
                                >
                                  {breakOptions.map((time) => (
                                    <MenuItem key={time} value={time}>
                                      {time}
                                    </MenuItem>
                                  ))}
                                </TextField>
                              ) : (
                                <Box sx={{ color: row.approvalStatus === 'Disapproved' ? 'red' : 'none' }}>
                                  {row.overtime}
                                </Box>
                              )}
                            </TableCell>

                            {/* Total Hours */}
                            {/* <TableCell sx={{ border: "2px solid #3C6BA5", textAlign: "center" }}>
        {row.editMode ? (
          <TextField
            size="small"
            value={row.totalHours}
            onChange={(e) => handleChange(wIdx, i, "totalHours", e.target.value)}
          />
        ) : (
          row.totalHours
        )}
      </TableCell> */}

                            <TableCell
                              sx={{ borderBottom: 'none', textAlign: 'center', py: 0.2, border: '1px solid #a4b0bf' }}
                            >
                              <Box sx={{ color: row.approvalStatus === 'Disapproved' ? 'red' : 'none' }}>
                                {row.totalHours}
                              </Box>
                            </TableCell>

                            {/* Edit Button */}
                            <TableCell
                              sx={{ border: '1px solid #a4b0bf', borderBottom: 'none', textAlign: 'center', py: 0.2 }}
                            >
                              {/* <Button
          variant="contained"
          size="small"
          sx={{ bgcolor: row.editMode ? "#2ecc71" : "#345da7" }}
          onClick={() => toggleEdit(wIdx, i)}
        >
          {row.editMode ? "Save" : "Edit"}
        </Button> */}

                              {/* <Button
  variant="contained"
  size="small"
  sx={{ bgcolor: row.editMode ? "#3C6BA5" : "#3C6BA5" }}
  onClick={() => {
    if (row.editMode) {
      saveDay(wIdx, i);   
    } else {
      toggleEdit(wIdx, i); 
    }
  }}
>
             {row.editMode ? "Save" : "Edit"} 
            </Button> */}

                              <Button
                                variant="contained"
                                sx={{ bgcolor: row.editMode ? '#3C6BA5' : '#3C6BA5', py: 0 }}
                                size="small"
                                disabled={row.approvalStatus === 'Approved'}
                                onClick={() => {
                                  if (row.editMode) {
                                    saveDay(wIdx, i, week.id);
                                  } else {
                                    toggleEdit(wIdx, i, row._id);
                                  }
                                }}
                              >
                                {row.editMode ? 'Save' : 'Edit'}
                              </Button>
                            </TableCell>

                            {/* Approve Button */}

                            <TableCell
                              sx={{ border: '1px solid #a4b0bf', borderBottom: 'none', textAlign: 'center', py: 0.2 }}
                            >
                              {/* <Button
    variant="contained"
      disabled={isFromBtn1}
    sx={{ bgcolor: "#3C6BA5", minWidth: 80 }}
    onClick={() => approveTime(row._id)}
  >
                Approve
  </Button>  */}

                              <Button
                                variant="contained"
                                disabled={
                                  TokenData.clickedButton === 'btn1' ||
                                  row.approvalStatus === 'Approved' ||
                                  row.approvalStatus === 'Disapproved'
                                }
                                //   disabled={ row.approvalStatus === "Approved" }
                                sx={{ bgcolor: '#3C6BA5', minWidth: 80, py: 0 }}
                                onClick={() => fun(row._id)}
                              >
                                {row.approvalStatus === 'Approved' ? 'Approved' : 'Approve'}
                              </Button>

                              {/* 
  <Button
    variant="contained"
      disabled={isFromBtn1}
    sx={{ bgcolor: "#3C6BA5", minWidth: 95, ml: 1 }}
    onClick={() => openDisapprove(row._id)}
  >
                 Disapprove
  </Button>  */}

                              {/* <Button
          variant="contained"
           sx={{ bgcolor: "#3C6BA5", minWidth: 95, ml: 1 ,py:0}} 

           disabled={TokenData.clickedButton==="btn1" || row.approvalStatus === "Approved" || row.approvalStatus === "Disapproved"}
          // disabled={row.approvalStatus === "Approved" || row.approvalStatus === "Disapproved"}

         onClick={() => openDisapprove(row._id)}
          >
   {row.approvalStatus === "Disapproved"
    ? "Rejected"
     : "Reject"} 
       </Button> */}

                              <Tooltip title={(row.approvalStatus === 'Disapproved' && row?.Note) || ''} arrow>
                                <span>
                                  <Button
                                    variant="contained"
                                    sx={{
                                      bgcolor: '#3C6BA5',
                                      minWidth: 95,
                                      ml: 1,
                                      py: 0,
                                      border: row.approvalStatus === 'Disapproved' ? '2px solid red' : 'none',
                                    }}
                                    disabled={
                                      TokenData.clickedButton === 'btn1' ||
                                      row.approvalStatus === 'Approved' ||
                                      row.approvalStatus === 'Disapproved'
                                    }
                                    onClick={() => openDisapprove(row._id)}
                                  >
                                    {row.approvalStatus === 'Disapproved' ? 'Rejected' : 'Reject'}
                                  </Button>
                                </span>
                              </Tooltip>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>

                {/* <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                mt: 2,
                gap: 2,
                flexWrap: "wrap",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  border: "3px solid black",
                //   justifyContent: "center",
                  borderRadius: "8px",
                  px: 2,
                  py: 1,
                  gap: 5,
                  flexWrap: "wrap",
                  width:470
                }}
              >
                <Typography >Total Hours:</Typography>
                 <Typography >{totals.working}</Typography>
                <Typography >{totals.overtime}</Typography>
                <Typography >{totals.total}</Typography>
              </Box>

              <Button
                variant="contained"
                sx={{
                  background: "#9eff84",
                //  color: "#004700",
                  border: "3px solid black",
                  borderRadius: "8px",
                  minWidth: 340,
                }}
              >
                Paid
              </Button>
            </Box>
 */}

                {/* 
<Grid container spacing={2} alignItems="center" sx={{ mt: 2 }}>

  <Grid item xs={12} md={6} sx={{marginLeft:'24%'}}>
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        border: "2px solid #3C6BA5",
           height: "31px",
        borderRadius: "8px",
        px: 2,
        py: 1,
      }}
    >
      <Typography fontWeight={600}>Total Hours:</Typography>

      <Box sx={{ display: "flex", gap: 14 }}>
        <Typography>{totals.working}</Typography>
        <Typography>{totals.overtime}</Typography>
        <Typography>{totals.total}</Typography>
      </Box>
    </Box>





  </Grid>

  <Grid item xs={12} md={3}>
   





      <Button
  fullWidth
 // variant="contained"
  sx={{
    background:  week.paymentStatus=== "Paid" ? "#2ECC71":"#CB4335",
    border: "2px solid #3C6BA5",
    borderRadius: "8px",
    height: "31px",
    color: "#fff"
  }}

  disabled={week.
paymentStatus==="Paid"}
  onClick={() => updateWeekPaymentStatus(week.id, week.weekNumber)}
>
        {week.paymentStatus ==="Paid" ? "Paid" : "Unpaid"}
     </Button>




  </Grid>
</Grid> */}

                {/* 

 <Grid container spacing={2} alignItems="center" sx={{ mt: 2 }}>
  
  
  <Grid
    item
    xs={12}
    md={6}
    lg={6}                 
    sx={{
      ml: { xs: 0, lg: "24%" }, 
    }}
  >
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
         border: "1px solid #3C6BA5",
        borderRadius: "8px",
        px: 2,
        py: 1,

        height: { xs: "26px", lg: "26px" },

      
        gap: { xs: 1, lg: 0 },
      }}
    >
      <Typography fontWeight={600}  sx={{width:'100px'}}>Total Hours:</Typography>

      <Box
        sx={{
          display: "flex",
          width: { xs: "100%", lg: "auto" },
          justifyContent: { xs: "space-between", lg: "flex-end" },
          gap: { xs: 2, lg: 10 },
        }}
      >
       
        <Typography  sx={{
      ml: { xs: "10%" }, 
    }}>{totals.working}</Typography>
        <Typography>{totals.overtime}</Typography>
        <Typography>{totals.total}</Typography>
      </Box>
    </Box>
  </Grid>


  <Grid
    item
    xs={12}     
    md={6}
    lg={3}      
  >
    <Button
      fullWidth                   
      sx={{
        backgroundColor:
          week.paymentStatus === "Paid" ? "#2ECC71" : "#CB4335",
     border: "1px solid #3C6BA5",
        borderRadius: "8px",
        height: { xs: "26px", lg: "26px" },
        color: "#fff",
      }}
      disabled={week.paymentStatus === "Paid"}
      onClick={() =>
        updateWeekPaymentStatus(week.id, week.weekNumber)
      }
    >
      {week.paymentStatus === "Paid" ? "Paid" : "Unpaid"}
    </Button>
  </Grid>
</Grid>

 */}

                <Grid container spacing={2} alignItems="center" sx={{ mt: 2 }}>
                  <Grid
                    item
                    xs={12}
                    md={6}
                    lg={6}
                    sx={{
                      ml: { xs: 0, lg: '24%' },
                    }}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',

                        border: '1px solid #3C6BA5',
                        borderRadius: '8px',

                        px: 2,
                        py: 1,

                        height: '26px',
                        overflow: 'hidden',
                        whiteSpace: 'nowrap',

                        gap: { xs: 1, lg: 0 },
                      }}
                    >
                      <Typography
                        fontWeight={600}
                        sx={{
                          width: '100px',
                          whiteSpace: 'nowrap',
                          lineHeight: '26px',
                          flexShrink: 0,
                        }}
                      >
                        {week?.generatedBy === 'Mannually' ? 'Total Hours (Manually Upload)' : 'Total Hours: '}
                      </Typography>

                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          width: { xs: '100%', lg: 'auto' },
                          justifyContent: { xs: 'space-between', lg: 'flex-end' },
                          gap: { xs: 2, lg: 10 },
                          whiteSpace: 'nowrap',
                        }}
                      >
                        <Typography
                          sx={{
                            pl: { xs: 0, sm: 0, md: 5, lg: 5 },
                          }}
                        >
                          {totals.working}
                        </Typography>
                        <Typography
                          sx={{
                            pl: { xs: 0, sm: 0, md: 5, lg: 5 },
                          }}
                        >
                          {totals.overtime}
                        </Typography>

                        <Typography sx={{ pl: { xs: 0, sm: 0, md: 5, lg: 5 } }}>
                          {week?.generatedBy === 'Mannually' ? week?.totalHoursPerWeek : totals?.total}
                        </Typography>
                      </Box>
                    </Box>
                  </Grid>

                  <Grid item xs={12} md={6} lg={3}>
                    <Button
                      fullWidth
                      sx={{
                        backgroundColor: week.paymentStatus === 'Paid' ? '#2ECC71' : '#CB4335',

                        border: '1px solid #3C6BA5',
                        borderRadius: '8px',

                        height: '26px',
                        whiteSpace: 'nowrap',

                        color: '#fff',
                      }}
                      disabled={
                        week.paymentStatus === 'Paid' || TokenData.clickedButton === 'btn1' || !isWeekActionCompleted
                      }
                      onClick={() => updateWeekPaymentStatus(week.id, week.weekNumber)}
                    >
                      {week.paymentStatus === 'Paid' ? 'Paid' : 'Unpaid'}
                    </Button>
                  </Grid>
                </Grid>
              </Box>
            );
          })}

          {/* <TableRow sx={{ background: "#f3f6fb", fontWeight: 700 }}>

    <TableCell colSpan={5} align="right">
      <b>Total</b>
    </TableCell>

   
    <TableCell align="right">
      7865
    </TableCell>

  
    <TableCell align="right">
      86
    </TableCell>

  
    <TableCell align="right">
      745
    </TableCell>

   
    <TableCell />

   
    <TableCell />
                   </TableRow> */}

          {/* ===== GRAND TOTAL OF ALL WEEKS ===== */}

          <Grid container spacing={2} alignItems="center" sx={{ mt: 2 }}>
            {/* Total Hours Box */}
            <Grid
              item
              xs={12}
              md={6}
              lg={7}
              sx={{
                ml: { xs: 0, lg: '16%' },
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',

                  border: '3px solid #3C6BA5',
                  borderRadius: '8px',

                  px: 2,
                  py: 1,

                  height: '26px',
                  overflow: 'hidden',
                  whiteSpace: 'nowrap',

                  gap: { xs: 0.3, lg: 0 },
                }}
              >
                {/* Total Hours */}
                <Typography
                  fontWeight={600}
                  sx={{
                    width: '150px',
                    whiteSpace: 'nowrap',
                    lineHeight: '32px',
                    flexShrink: 0,
                  }}
                >
                  Total Monthly Billable
                </Typography>

                {/* Values */}
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    width: { xs: '100%', lg: 'auto' },
                    justifyContent: { xs: 'space-between', lg: 'flex-end' },
                    gap: { xs: 2, lg: 10 },
                    whiteSpace: 'nowrap',
                  }}
                >
                  <Typography
                    sx={{
                      pl: { xs: 0, sm: 0, md: 5, lg: 5 },
                    }}
                  >
                    {allTotals.working}
                  </Typography>
                  <Typography
                    sx={{
                      pl: { xs: 0, sm: 0, md: 5, lg: 5 },
                    }}
                  >
                    {allTotals.overtime}
                  </Typography>
                  <Typography
                    sx={{
                      pl: { xs: 0, sm: 0, md: 5, lg: 5 },
                    }}
                  >
                    {allTotals.total}
                  </Typography>
                </Box>
              </Box>
            </Grid>

            {/* Paid / Unpaid Button */}
            <Grid item xs={12} md={6} lg={3}>
              <Button
                fullWidth
                sx={{
                  backgroundColor: allPaid ? '#2ECC71' : '#CB4335',

                  //  week.paymentStatus === "Paid" ? "#2ECC71" : "#CB4335",
                  border: '3px solid #3C6BA5',
                  borderRadius: '8px',

                  height: '26px',
                  whiteSpace: 'nowrap',

                  color: '#fff',
                }}
                disabled={allPaid || TokenData.clickedButton === 'btn1'}
                onClick={handleMarkMonthPaid}
              >
                {allPaid ? 'Paid' : 'Unpaid'}
                {/* {week.paymentStatus === "Paid" ? "Paid" : "Unpaid"} */}
              </Button>
            </Grid>
          </Grid>

          <Dialog open={openDisapproveModal} onClose={() => setOpenDisapproveModal(false)}>
            <Box sx={{ p: 3, width: 400 }}>
              {/* <Typography variant="h6" mb={2} sx={{display:"flex", justifyContent:"center"}}>
      Disapprove it
    </Typography> */}

              <TextField
                fullWidth
                multiline
                rows={4}
                label="Note"
                value={disapproveNote}
                onChange={(e) => setDisapproveNote(e.target.value)}
              />

              <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2, gap: 1 }}>
                <Button onClick={() => setOpenDisapproveModal(false)}>Cancel</Button>

                <Button
                  variant="contained"
                  sx={{ bgcolor: '#3C6BA5', minWidth: 80, py: 0 }}
                  onClick={() => disapproveTime()}
                >
                  Submit
                </Button>
              </Box>
            </Box>
          </Dialog>

          <Modal open={openApproveModal} onClose={() => setOpenApproveModal(false)}>
            <Box
              sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: { xs: '90%', sm: '50%', md: '40%' },
                border: '3px solid #3C6BA5',
                boxShadow: 24,
                p: 3,
                borderRadius: 3,
                bgcolor: 'background.paper',
              }}
            >
              <Typography variant="h6" color="red" textAlign="center">
                Do you want to Approve
              </Typography>

              <Stack
                flexDirection={{ xs: 'column', md: 'row' }}
                gap={2}
                mt={2}
                alignItems="center"
                justifyContent="center"
              >
                <Button
                  color="custom"
                  variant="contained"
                  // fullWidth={{ xs: true, md: false }}
                  onClick={() => approveTime()}
                >
                  Yes
                </Button>
                <Button
                  color="custom"
                  variant="contained"
                  // fullWidth={{ xs: true, md: false }}
                  onClick={() => setOpenApproveModal(false)}
                >
                  No
                </Button>
              </Stack>
            </Box>
          </Modal>
        </Box>
      </Box>
    </>
  );
}
